import { FC } from 'react';
import { createRoot, Root } from 'react-dom/client';
import videojs from 'video.js';

export type BaseCustomComponentVideo = {
  player: videojs.Player;
};

type ActionType = (...args: any[]) => void;

const vjsComponent = videojs.getComponent('Component');

type AddElementProps = {
  player: videojs.Player;
  Component: FC<any>;
  props: { [key: string]: any };
  action?: ActionType;
};
class AddElement extends vjsComponent {
  private props: { [key: string]: any };
  private Component: FC<any>;
  private action?: ActionType;
  private rootElement: Root;
  // private player: videojs.Player;

  constructor({ player, Component, props, action }: AddElementProps) {
    super(player);

    this.props = props;
    this.Component = Component;
    this.action = action;
    // this.player = player;

    this.rootElement = createRoot(this.el());

    /* Bind the current class context to the mount method */
    this.mount = this.mount.bind(this);

    /* When player is ready, call method to mount React component */
    player.ready(() => this.mount());

    /* Remove React root when component is destroyed */
    // this.on('dispose', () => this.rootElement.unmount());
  }

  mount(): void {
    const Component = this.Component;

    this.rootElement.render(
      <>
        <Component vjsComponent={this} {...this.props} player={this.player()} />
      </>
    );
  }
}

type addElementToVideojsProps = {
  parentNode: videojs.Player;
  player: videojs.Player;
  Component: FC<any>;
  props: { [key: string]: any };
  position?: number;
};
export const addElementToVideojs = ({
  parentNode,
  player,
  Component,
  props,
  position,
}: addElementToVideojsProps): void => {
  const element = new AddElement({
    player,
    Component,
    props,
  });

  parentNode.addChild(element, {}, position);
};
